import { addNamespace } from '@Utils/actions';
import { createAction } from 'redux-actions';

export const clearAll = createAction(addNamespace('global/clearAll'));
